import React, { ReactNode } from 'react'

import { Card as AntCard } from 'antd'

interface CardProps {
  size?: 'default' | 'small'
  title?: string | ReactNode
  children: ReactNode
  extra?: string | ReactNode
  className?: string
  actions?: React.ReactNode[]
  style?: React.CSSProperties
  loading?: boolean
  id?: string
}

const Card = (props: CardProps) => {
  return <AntCard {...props}>{props.children}</AntCard>
}

export default Card
